import React from 'react';
import ReactDOM from 'react-dom';
import Countdown from 'react-countdown';


// Random component
const Completionist = () => Turbolinks.visit('');

// Renderer callback with condition
const renderer = ({ hours, minutes, seconds, completed }) => {
  console.log('hourse is', hours)
  return <span>{hours}:{minutes}:{seconds} Ke konsultasi anda</span>;
  // if (completed) {
  //   // Render a completed state
  //   return <Completionist />;
  // } else {
  //   // Render a countdown
  //   return <span>{hours}:{minutes}:{seconds}</span>;
  // }
};

export default class CountDown extends React.Component {
  render() {
    // console.log(this.props)
    // const {scrollPosition} = this.props;
    return (
      <Countdown 
        date={this.props.time}
        daysInHours={true}
        // renderer={renderer}
        precision={2}
        onComplete={() => (
          Turbolinks.visit('')
        )}
        zeroPadTime={2}

      />
     
    );
  }
}
